<template>
	<v-app class="app">
		<v-main>
			<v-alert :value="pagoDesactivado" type="warning" dense class="ma-0"
							 transition="fade-transition">
				Nuestros proveedores de <b>medio de pago están presentando problemas</b>, por lo que
				momentáneamente hemos desactivado la recepción de pagos. Lamentamos los inconvenientes,
				por favor vuelva más tarde.
			</v-alert>
			<v-alert :value="esAmbienteNoProductivo" type="warning" dismissible dense class="ma-0"
							 transition="fade-transition">
				Este ambiente <b>no es productivo</b> y es sólo para efectos de <b>pruebas</b>.
				¡No lo use para operar con productos de Vessi!
			</v-alert>
			<v-alert :value="versionDesactualizada" type="info" dense class="ma-0"
							 transition="fade-transition">
				¡Hola! Hay una <b>nueva versión</b> disponible de esta aplicación.
				Por favor <b>actualice</b> esta página a fin de asegurar su continuidad operativa.
				En caso que esta alerta persista, recomendamos <b>borrar el caché</b> del navegador
				y luego intentar <b>actualizar</b> nuevamente.
			</v-alert>
			<v-container>
				<router-view>
					<!-- Vista router -->
				</router-view>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
import * as config from '@/config';
import * as version from '@/library/version';
import * as moment from 'moment';
import { API } from 'aws-amplify';

export default {
	data: () => ({
		esAmbienteNoProductivo: config.ambienteNoProductivo,
		versionDesactualizada: false,
		pagoDesactivado: config.desactivarPago,
	}),
	methods: {
		iniciarChequeoVersion: async function() {
			let vm = this;
			// Obtener datos de versión locales
			const datosVersionLocal = version.getVersionData();
			if(!datosVersionLocal) {
				// Abortar, nada que hacer
				return;
			}
			while(true) {
				// Obtener datos de versión remotos
				let datosVersionRemoto;
				const apiName = config.autocontratarApiName;
				const path = `/version/front`;
				const init = {
					headers: {},
				};
				try {
					datosVersionRemoto = await API.get(apiName, path, init);
				}
				catch (e) {
					// Ignorar, nada que hacer... por ahora.
				}
				// Si ambos datos están, compararlos y avisar si corresponde
				if(datosVersionRemoto) {
					let fechaHoraVersionLocal = moment.utc(datosVersionLocal.publishUtcDatetime);
					let fechaHoraVersionRemota = moment.utc(datosVersionRemoto.publishUtcDatetime);
					let versionAtrasada = fechaHoraVersionLocal.isBefore(fechaHoraVersionRemota);
					if(versionAtrasada) {
						// Mostrar alerta y no seguir chequeando, pues este front ya quedó atrasado
						vm.versionDesactualizada = true;
						break;
					}
				}
				// Esperar 5 minutos y chequear de nuevo
				const intervalo = config.intervaloChequeoVersion * 60 * 1000; // Milisegundos
				await (new Promise(res => setTimeout(res, intervalo)));
			}
		},
	},
	mounted: function() {
		let vm = this;
		vm.iniciarChequeoVersion();
	},
};
</script>

<style scoped>
.app {
	background-color: #f5f5f5;
}
</style>